(function () {
  if (window.__bundleCartTimerLoaded) return;
  window.__bundleCartTimerLoaded = true;

  var STORAGE_KEY = 'bundleCartTimerEnd';
  var DURATION_MS = 3 * 60 * 1000;
  var GRACE_MS = 2 * 60 * 1000;

  function formatTime(ms) {
    var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function getEnd() {
    var raw = null;
    try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    return raw ? parseInt(raw, 10) : null;
  }

  function startTimer() {
    var end = Date.now() + DURATION_MS;
    try { localStorage.setItem(STORAGE_KEY, String(end)); } catch (e) {}
    render();
  }

  window.startBundleCartTimer = startTimer;

  function injectPagePilotDrawerBadge() {
    var header = document.querySelector('[id$="__static-pagepilot_drawer_group_header"]');
    if (!header || header.querySelector('[data-timer-root]')) return;
    var titleEl = header.querySelector('p');
    if (!titleEl) return;
    var badge = document.createElement('span');
    badge.className = 'pp-cart-timer-badge';
    badge.setAttribute('data-timer-root', '');
    badge.setAttribute('data-timer-format', 'short');
    badge.hidden = true;
    titleEl.parentNode.insertBefore(badge, titleEl.nextSibling);
  }

  function render() {
    injectPagePilotDrawerBadge();
    var roots = document.querySelectorAll('[data-timer-root]');
    if (!roots.length) return;

    var end = getEnd();

    if (!end) {
      roots.forEach(function (el) { el.hidden = true; });
      return;
    }

    var remaining = end - Date.now();

    roots.forEach(function (root) {
      var format = root.getAttribute('data-timer-format') || 'full';
      var textEl = root.querySelector('[data-timer-text]') || root;

      if (remaining > 0) {
        root.hidden = false;
        root.classList.remove('is-urgent');
        textEl.textContent = format === 'short'
          ? formatTime(remaining)
          : 'Panier réservé pendant ' + formatTime(remaining);
      } else if (remaining > -GRACE_MS) {
        root.hidden = false;
        root.classList.add('is-urgent');
        textEl.textContent = '⏰ Dernière chance !';
      } else {
        root.hidden = true;
      }
    });

    if (remaining <= -GRACE_MS) {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }
  }

  function init() {
    render();
    setInterval(render, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();